// src/components/FileExplorer.js
import React, { useState } from 'react';
import { File, Folder, ChevronDown, ChevronRight } from 'lucide-react';

const FileExplorer = ({ projectFiles, selectedFiles, aiSelectedFiles, onToggleFile, onClose }) => {
  const [expandedFolders, setExpandedFolders] = useState(new Set());

  const handleDeselectAll = () => {
    // Clear all selected files
    selectedFiles.forEach(filePath => {
      onToggleFile(filePath);
    });
  };

  const toggleFolder = (folderPath) => {
    setExpandedFolders(prev => {
      const newExpanded = new Set(prev);
      if (newExpanded.has(folderPath)) {
        newExpanded.delete(folderPath);
      } else {
        newExpanded.add(folderPath);
      }
      return newExpanded;
    });
  };

  const renderFileTree = (node, level = 0) => {
    if (!node || typeof node !== 'object') return null;
    
    return Object.values(node).map(item => {
      if (!item || !item.name) return null;
      
      const isExpanded = expandedFolders.has(item.path);
      const isSelected = selectedFiles.includes(item.path);
      const isAISelected = aiSelectedFiles && aiSelectedFiles.includes(item.path);
      
      let itemClass = 'file-item';
      if (item.isFile) {
        itemClass += ' file';
        if (isSelected && isAISelected) {
          itemClass += ' selected ai-selected';
        } else if (isSelected) {
          itemClass += ' selected';
        } else if (isAISelected) {
          itemClass += ' ai-selected';
        }
      } else {
        itemClass += ' folder';
      }
      
      return (
        <div key={item.path} style={{ marginLeft: level * 20 }}>
          <div 
            className={itemClass}
            onClick={() => {
              if (item.isFile) {
                onToggleFile(item.path);
              } else {
                toggleFolder(item.path);
              }
            }}
          >
            {!item.isFile && (
              isExpanded ? <ChevronDown size={16} /> : <ChevronRight size={16} />
            )}
            {item.isFile ? <File size={16} /> : <Folder size={16} />}
            <span>{item.name}</span>
            {isAISelected && <span className="ai-badge">AI</span>}
          </div>
          {!item.isFile && isExpanded && renderFileTree(item.children, level + 1)}
        </div>
      );
    });
  };

  return (
    <div className="file-explorer-panel">
      <div className="file-explorer-header">
        <h3>Project Files</h3>
        <div>
          <span className="selected-count">{selectedFiles.length} selected</span>
          {selectedFiles.length > 0 && (
            <button 
              onClick={handleDeselectAll}
              style={{ 
                marginLeft: '10px',
                padding: '4px 8px',
                background: 'rgba(255, 82, 82, 0.2)',
                border: '1px solid rgba(255, 82, 82, 0.3)',
                borderRadius: '4px',
                color: '#fff',
                cursor: 'pointer'
              }}
            >
              Deselect All
            </button>
          )}
          <button onClick={onClose} style={{ marginLeft: '10px' }}>×</button>
        </div>
      </div>
      <div className="file-tree">
        {renderFileTree(projectFiles)}
      </div>
    </div>
  );
};

export default FileExplorer;